/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable object-curly-newline */
const InputsByLocation = {
    RecipientForm: {
        default: {
            firstname: { class: '', label: 'First Name' },
            lastname: { class: '', label: 'Last Name' },
            location: { class: '', label: 'Location Type' },
            relationship: { class: '', label: 'Relationship' },
            company: {
                class: 'display-none',
                label: 'Company Name',
                optional: true,
            },
            street: { class: '', label: 'Street Address' },
            apt: { class: '', label: 'Apartment/Suite/Other' },
            apofpo: { class: 'display-none', label: 'APO/FPO' },
            city: { class: '', label: 'City' },
            phone: { class: '', label: 'Phone Number', optional: true },
        },
        Business: {
            firstname: { class: '', label: 'First Name' },
            lastname: { class: '', label: 'Last Name' },
            location: { class: '', label: 'Location Type' },
            relationship: { class: '', label: 'Relationship' },
            company: { class: '', label: 'Company Name', optional: false },
            street: { class: '', label: 'Street Address' },
            apt: { class: '', label: 'Apartment/Suite/Other' },
            apofpo: { class: 'display-none', label: 'APO/FPO' },
            city: { class: '', label: 'City' },
            phone: { class: '', label: 'Phone Number', optional: true },
        },
        Hospital: {
            firstname: { class: '', label: 'First Name' },
            lastname: { class: '', label: 'Last Name' },
            location: { class: '', label: 'Location Type' },
            relationship: { class: '', label: 'Relationship' },
            company: { class: '', label: 'Hospital Name', optional: false },
            street: { class: '', label: 'Street Address' },
            apt: { class: '', label: 'Apartment/Suite/Other' },
            apofpo: { class: 'display-none', label: 'APO/FPO' },
            city: { class: '', label: 'City' },
            phone: { class: '', label: 'Phone Number', optional: true },
        },
        School: {
            firstname: { class: '', label: 'First Name' },
            lastname: { class: '', label: 'Last Name' },
            location: { class: '', label: 'Location Type' },
            relationship: { class: '', label: 'Relationship' },
            company: { class: '', label: 'School Name', optional: false },
            street: { class: '', label: 'Street Address' },
            apt: { class: '', label: 'Apartment/Suite/Other' },
            apofpo: { class: 'display-none', label: 'APO/FPO' },
            city: { class: '', label: 'City' },
            phone: { class: '', label: 'Phone Number', optional: true },
        },
        Church: {
            firstname: { class: '', label: 'First Name' },
            lastname: { class: '', label: 'Last Name' },
            location: { class: '', label: 'Location Type' },
            relationship: { class: '', label: 'Relationship' },
            company: { class: '', label: 'Name of Church', optional: false },
            street: { class: '', label: 'Street Address' },
            apt: { class: '', label: 'Apartment/Suite/Other' },
            apofpo: { class: 'display-none', label: 'APO/FPO' },
            city: { class: '', label: 'City' },
            phone: { class: '', label: 'Phone Number', optional: true },
        },
        'Funeral home': {
            firstname: { class: '', label: 'First Name of Deceased' },
            lastname: { class: '', label: 'Last Name of Deceased' },
            location: { class: '', label: 'Location Type' },
            relationship: { class: '', label: 'Relationship' },
            company: {
                class: '',
                label: 'Name of Funeral Home',
                optional: false,
            },
            street: { class: '', label: 'Street Address' },
            apt: { class: '', label: 'Apartment/Suite/Other' },
            apofpo: { class: 'display-none', label: 'APO/FPO' },
            city: { class: '', label: 'City' },
            phone: {
                class: '',
                label: 'Funeral Home Telephone',
                optional: true,
            },
        },
        'P.O.Box': {
            firstname: { class: '', label: 'First Name' },
            lastname: { class: '', label: 'Last Name' },
            location: { class: '', label: 'Location Type' },
            relationship: { class: '', label: 'Relationship' },
            company: {
                class: 'display-none',
                label: 'Company Name',
                optional: true,
            },
            street: { class: '', label: 'P.O.Box' },
            apt: { class: '', label: 'Address Line 2' },
            apofpo: { class: 'display-none', label: 'APO/FPO' },
            city: { class: '', label: 'City' },
            phone: { class: '', label: 'Phone Number', optional: true },
        },
        'APO/FPO': {
            firstname: { class: '', label: 'First Name' },
            lastname: { class: '', label: 'Last Name' },
            location: { class: '', label: 'Location Type' },
            relationship: { class: '', label: 'Relationship' },
            company: {
                class: 'display-none',
                label: 'Company Name',
                optional: true,
            },
            street: { class: '', label: 'Unit/Ship/PSC Number' },
            apt: { class: '', label: 'Box/Hull Number' },
            apofpo: { class: '', label: 'APO/FPO' },
            city: { class: 'display-none', label: 'City' },
            phone: { class: '', label: 'Phone Number', optional: true },
        },
    },
    BillingForm: {
        default: {
            firstname: { class: '', label: 'First Name' },
            lastname: { class: '', label: 'Last Name' },
            location: { class: 'display-none', label: 'Location Type' },
            relationship: { class: 'display-none', label: 'Relationship' },
            company: { class: '', label: 'Company Name', optional: true },
            street: { class: '', label: 'Street Address' },
            apt: { class: '', label: 'Apartment/Suite/Other' },
            apofpo: { class: 'display-none', label: 'APO/FPO' },
            city: { class: '', label: 'City' },
            phone: { class: '', label: 'Phone Number', optional: false },
        },
    },
    GiftListRecipientForm: {
        default: {
            firstname: { class: '', label: 'First Name' },
            lastname: { class: '', label: 'Last Name' },
            location: { class: 'display-none', label: 'Location Type' },
            relationship: { class: 'display-none', label: 'Relationship' },
            company: {
                class: '',
                label: 'Company Name',
                optional: true,
            },
            street: { class: '', label: 'Street Address' },
            apt: { class: '', label: 'Apartment/Suite/Other' },
            apofpo: { class: 'display-none', label: 'APO/FPO' },
            city: { class: '', label: 'City' },
            phone: {
                class: 'display-none',
                label: 'Phone Number',
                optional: true,
            },
        },
        Business: {
            firstname: { class: '', label: 'First Name' },
            lastname: { class: '', label: 'Last Name' },
            location: { class: '', label: 'Location Type' },
            relationship: { class: 'display-none', label: 'Relationship' },
            company: { class: '', label: 'Company Name', optional: false },
            street: { class: '', label: 'Street Address' },
            apt: { class: '', label: 'Apartment/Suite/Other' },
            apofpo: { class: 'display-none', label: 'APO/FPO' },
            city: { class: '', label: 'City' },
            phone: {
                class: 'display-none',
                label: 'Phone Number',
                optional: true,
            },
        },
    },
};

export default InputsByLocation;
